import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";

import {
  DocumentPage,
  type DocumentPageType,
  getDocumentPage,
} from "@/_pages/document";

type Params = {
  slug: string;
};

type PageProps = {
  cms: DocumentPageType;
};

const Page = (props: PageProps) => {
  const { cms } = props;

  return <DocumentPage document={cms} />;
};

export const getServerSideProps: GetServerSideProps<{}, Params> = async (
  context,
) => {
  const { res } = context;
  const { slug } = context.params!;

  return await loadPageWithGlobal(
    async () => {
      const { document } = await getDocumentPage(slug);

      return {
        ...document,
      };
    },
    { res },
  );
};

export default Page;
